import { GrCart } from "react-icons/gr";
import { styled, applyClassName } from "@glitz/react";
import { spacing, fontSize, white, red, green, darkGreen } from "../theme";
import { useCart } from "../context/CartContext";

type CartIconProps = {
  onOpen: () => void; // Funktion utan parametrar och utan returvärde
};
const CartIcon = ({ onOpen }: CartIconProps) => {
  const { cartItemCount } = useCart();

  return (
    <Wrapper>
      <ContentWrapper onClick={onOpen}>
        <IconWrapper>
          <Icon />
        </IconWrapper>
        {cartItemCount > 0 && <CartBadge>{cartItemCount}</CartBadge>}
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  justifyContent: "flex-end",
});

const ContentWrapper = styled.div({
  position: "relative",
});

const Icon = styled(applyClassName(GrCart), {
  fontSize: "30px",
  color: green,
  cursor: "pointer",
  ":hover": {
    color: darkGreen,
  },
});

const IconWrapper = styled.div({
  padding: { x: spacing.m, y: spacing.s },
});

const CartBadge = styled.span({
  cursor: "pointer",
  position: "absolute",
  top: spacing.xs,
  right: spacing.xs,
  backgroundColor: red,
  color: white,
  fontSize: fontSize.s,
  borderRadius: "9999px",
  paddingLeft: spacing.xs,
  paddingRight: spacing.xs,
});

export default CartIcon;
